import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import { API_GET, API_POST } from "../../helpers/api";
import * as actions from "../actions/offers";

import {
  GET_ACTIVE_OFFERS_REQUESTED,
  GET_MARKET_MATCHES_REQUESTED,
  GET_SYSTEM_PARTICIPANT_MATCHES_REQUESTED,
  GET_SYSTEM_PARTICIPANT_OFFERS_REQUESTED,
  SEND_MARKET_CANCELLED_MATCHES_REQUESTED,
} from "../types";
import moment from "moment";

function* watchGetSystemParticipantOffersRequested() {
  yield takeLatest(
    GET_SYSTEM_PARTICIPANT_OFFERS_REQUESTED,
    getSystemParticipantOffers
  );
}
function* watchGetSystemParticipantMatchesRequested() {
  yield takeLatest(
    GET_SYSTEM_PARTICIPANT_MATCHES_REQUESTED,
    getSystemParticipantMatches
  );
}
function* watchGetMarketMatchesRequested() {
  yield takeLatest(GET_MARKET_MATCHES_REQUESTED, getMarketMatches);
}
function* watchGetActiveOffersRequested() {
  yield takeLatest(GET_ACTIVE_OFFERS_REQUESTED, getActiveOffers);
}

function* watchSendCancalledMatchRequested() {
  yield takeLatest(
    SEND_MARKET_CANCELLED_MATCHES_REQUESTED,
    sendCancalledMatchCertificate
  );
}

function* getMarketMatches(action) {
  try {
    const res = yield call(apiGetMarketMatches, action.payload);
    let marketMatches = res?.data?.items?.reduce((acc, value) => {
      let organizationId = action.payload.organizationId;

      if (
        action.payload.isMarketResult &&
        ["VALID"].includes(value?.matchStatus?.value)
      ) {
        acc.push({
          id: value.bundleId,
          matchPrice: value.matchPrice,
          matchAmount: value.matchTotalAmount,
          sellOrganization: value.sellOrganizationName,
          matchDate: value.matchedAt,
          buyerOrganization: value.buyOrganizationName,
          matchList: value.matchList,
          details: {
            matchBundle: {
              buyOrderGroupId: value.buyOrderGroupId,
              sellOrderGroupId: value.sellOrderGroupId,
            },
          },
          buyOrder: value.buyOrderGroupId,
          sellOrder: value.sellOrderGroupId,
          contractName: value.contractName,
          status: value.matchStatus,
          price:
            value.buyOrganizationId === organizationId
              ? value.orderBuyPrice
              : value.orderSellPrice,
          quantity:
            value.buyOrganizationId === organizationId
              ? value.orderTotalBuyAmount
              : value.orderTotalSellAmount,
          orderId:
            value.buyOrganizationId === organizationId
              ? value.buyOrderGroupId
              : value.sellOrderGroupId,
          matchQuantity: value.matchTotalAmount,
          matchStatusDescription: value.matchStatusDescription,
          cancelable: value.cancelable,
        });
      } else if (
        !action.payload.isMarketResult &&
        ["VALID", "CANCELLED"].includes(value?.matchStatus?.value)
      ) {
        acc.push({
          id: value.bundleId,
          matchPrice: value.matchPrice,
          matchAmount: value.matchTotalAmount,
          sellOrganization: value.sellOrganizationName,
          matchDate: value.matchedAt,
          buyerOrganization: value.buyOrganizationName,
          matchList: value.matchList,
          details: {
            matchBundle: {
              buyOrderGroupId: value.buyOrderGroupId,
              sellOrderGroupId: value.sellOrderGroupId,
            },
          },
          buyOrder: value.buyOrderGroupId,
          sellOrder: value.sellOrderGroupId,
          contractName: value.contractName,
          status: value.matchStatus,
          price:
            value.buyOrganizationId === organizationId
              ? value.orderBuyPrice
              : value.orderSellPrice,
          quantity:
            value.buyOrganizationId === organizationId
              ? value.orderTotalBuyAmount
              : value.orderTotalSellAmount,
          orderId:
            value.buyOrganizationId === organizationId
              ? value.buyOrderGroupId
              : value.sellOrderGroupId,
          matchQuantity: value.matchTotalAmount,
          matchStatusDescription: value.matchStatusDescription,
          cancelable: value.cancelable,
        });
      }

      return acc;
    }, []);
    yield put(
      actions.getMarketMatchesSucceeded({
        marketMatches,
        isMarketResult: action.payload.isMarketResult,
      })
    );
  } catch (err) {
    yield put(actions.getMarketMatchesFailed());
  }
}
function* getActiveOffers(action) {
  try {
    const res = yield call(apiGetActiveOffers, action.payload);

    let offers = res.data.items.reduce((acc, value) => {
      acc.push({
        ...value,
        shownId: value.orderGroupDto.id,
        status: value.remainingAmount === 0 ? "SOLD" : value.status,
      });
      return acc;
    }, []);
    yield put(actions.getActiveOffersSucceeded(offers));
  } catch (err) {
    yield put(actions.getActiveOffersFailed());
  }
}

function* getSystemParticipantMatches(action) {
  try {
    const res = yield call(apiGetSystemParticipantMatches, action.payload);
    let systemParticipantMatches = res?.data?.items?.reduce((acc, value) => {
      let organizationId = action.payload.organizationId;

      if (
        action.payload.isMarketResult &&
        ["VALID"].includes(value?.matchStatus?.value)
      ) {
        acc.push({
          id: value?.bundleId,
          matchList: value?.matchList,
          organizationName:
            value.buyOrganizationId === organizationId
              ? value.buyOrganizationName
              : value.sellOrganizationName,
          userName:
            value.buyOrganizationId === organizationId
              ? value.matchList[0]?.buyOrder?.createdBy
              : value.matchList[0]?.sellOrder?.createdBy,
          contractName: value.contractName,
          objectionAble: value.objectionAble,
          orderId:
            value.buyOrganizationId === organizationId
              ? value.buyOrderGroupId
              : value.sellOrderGroupId,
          buyerOrganization: value.buyOrganizationName,
          sellerOrganization: value.sellOrganizationName,
          offerDate:
            value.buyOrganizationId === organizationId
              ? value.matchList[0]?.buyOrder?.givenAt
              : value.matchList[0]?.sellOrder.givenAt,
          price:
            value.buyOrganizationId === organizationId
              ? value.orderBuyPrice
              : value.orderSellPrice,
          quantity:
            value.buyOrganizationId === organizationId
              ? value.orderTotalBuyAmount
              : value.orderTotalSellAmount,
          matchQuantity: value.matchTotalAmount,
          matchPrice: value.matchPrice,
          matchStatusDescription: value.matchStatusDescription,
          matchDate: value.matchedAt,
          orderType:
            value.buyOrganizationId === organizationId ? "BUY" : "SELL",
          status: value.matchStatus,
          matchAmount: value.matchTotalAmount,
        });
      } else if (
        !action.payload.isMarketResult &&
        ["VALID", "CANCELLED"].includes(value.matchStatus.value)
      ) {
        acc.push({
          id: value?.bundleId,
          matchList: value?.matchList,
          contractName: value.contractName,
          organizationName:
            value.buyOrganizationId === organizationId
              ? value.buyOrganizationName
              : value.sellOrganizationName,
          userName:
            value.buyOrganizationId === organizationId
              ? value?.matchList[0].buyOrder.createdBy
              : value?.matchList[0].sellOrder.createdBy,
          objectionAble: value.objectionAble,
          orderId:
            value.buyOrganizationId === organizationId
              ? value.buyOrderGroupId
              : value.sellOrderGroupId,
          buyerOrganization: value.buyOrganizationName,
          sellerOrganization: value.sellOrganizationName,
          price:
            value.buyOrganizationId === organizationId
              ? value.orderBuyPrice
              : value.orderSellPrice,
          quantity:
            value.buyOrganizationId === organizationId
              ? value.orderTotalBuyAmount
              : value.orderTotalSellAmount,
          matchQuantity: value.matchTotalAmount,
          matchPrice: value.matchPrice,
          matchStatusDescription: value.matchStatusDescription,
          matchDate: value.matchedAt,
          orderType:
            value.buyOrganizationId === organizationId ? "BUY" : "SELL",
          status: value.matchStatus,
          matchAmount: value.matchTotalAmount,
          offerDate:
            value.buyOrganizationId === organizationId
              ? value.matchList[0]?.buyOrder?.givenAt
              : value.matchList[0]?.sellOrder.givenAt,
        });
      }
      return acc;
    }, []);

    yield put(
      actions.getSystemParticipantMatchesSucceeded({
        systemParticipantMatches,
        totalItemCount: res.data.totalItemCount,
        totalPageCount: res.data.totalPageCount,
        isMarketResult: action.payload.isMarketResult,
      })
    );
  } catch (err) {
    yield put(actions.getSystemParticipantMatchesFailed());
  }
}
function* getSystemParticipantOffers(action) {
  try {
    const res = yield call(apiGetSystemParticipantOffers, action.payload);
    let systemParticipantOffers = res.data.items.reduce((acc, value) => {
      acc.push({
        id: value.id,
        shownId: value.orderGroupDto.id,
        date: moment(value.modifiedAt).format("DD.MM.YYYY HH:mm:ss"),
        type: "standart",
        amount: value.amount,
        price: value.price,
        remainingAmount: value.remainingAmount,
        orderType: value.orderType,
        status: statusCalculator({
          status: value.status,
          amount: value.amount,
          remainingAmount: value.remainingAmount,
        }),
        offerStatus: offerStatusCalculator({
          status: value.status,
          amount: value.amount,
          remainingAmount: value.remainingAmount,
        }),
        reason: value.reason,
      });
      return acc;
    }, []);
    yield put(
      actions.getSystemParticipantOffersSucceeded({
        systemParticipantOffers,
        totalItemCount: res.data.totalItemCount,
        totalPageCount: res.data.totalPageCount,
      })
    );
  } catch (err) {
    yield put(actions.getSystemParticipantOffersFailed());
  }
}

function* sendCancalledMatchCertificate(action) {
  try {
    const res = yield call(apiCancalledMatchCertificate, action.payload);

    yield put(actions.sendCancalledMatchesSucceeded(res));
  } catch (error) {
    yield put(actions.sendCancalledMatchesFailed(error?.response));
  }
}

export default function* offerSaga() {
  yield all([
    fork(watchGetMarketMatchesRequested),
    fork(watchGetActiveOffersRequested),
    fork(watchGetSystemParticipantMatchesRequested),
    fork(watchGetSystemParticipantOffersRequested),
    fork(watchSendCancalledMatchRequested),
  ]);
}
function statusCalculator({ status, amount, remainingAmount }) {
  let returningStatus = status;
  if (status === "OPEN" && remainingAmount === 0) {
    returningStatus = "SOLD";
  }
  if (status === "CLOSED" && remainingAmount !== 0) {
    returningStatus = "CANCELLED";
  }
  return returningStatus;
}

function offerStatusCalculator({ status, amount, remainingAmount }) {
  let returningStatus = "NON_MATCHES";
  if (status === "OPEN" && amount === remainingAmount) {
    returningStatus = "WAITING_MATCHES";
  }
  if (amount > remainingAmount && remainingAmount !== 0) {
    returningStatus = "PARTIAL_MATCHES";
  }
  if (remainingAmount === 0) {
    returningStatus = "MATCHED";
  }
  return returningStatus;
}

function apiGetMarketMatches(filter) {
  return API_GET("exchange-order-match/search", {
    contractId: filter.contractId,
    buyOrganizationId: filter.buyOrganizationId ? filter.buyOrganizationId : "",
    sellOrganizationId: filter.sellOrganizationId
      ? filter.sellOrganizationId
      : "",
    page: 0,
    size: 1000,
  });
}
function apiGetActiveOffers(filter) {
  if (filter.organizationId) {
    return API_GET("exchange-order/byOrganizationIdAndContractId", {
      organizationId: filter.organizationId,
      contractId: filter.contractId,
      page: 0,
      size: 1000,
    });
  } else {
    return API_GET("exchange-order/byContractId", {
      contractId: filter.contractId,
      page: 0,
      size: 1000,
    });
  }
}

function apiGetSystemParticipantMatches(reqParams) {
  return API_GET("exchange-order-match/search", {
    contractId: reqParams.contractId ? reqParams.contractId : "",
    buyOrSellOrganizationId: reqParams.organizationId
      ? reqParams.organizationId
      : "",
    contractType:
      reqParams.contractType && reqParams.contractType !== "-"
        ? reqParams.contractType
        : "",
    sessionDate: reqParams.period ? reqParams.period.replace("-", "") : "",
    page: reqParams?.page || 0,
    size: reqParams?.noPage ? 1000 : 10,
  });
}

function apiGetSystemParticipantOffers(reqParams) {
  return API_GET("exchange-order/group/search", {
    contractId: reqParams.contractId ? reqParams.contractId : "",
    organizationId: reqParams.organizationId ? reqParams.organizationId : "",
    contractType:
      reqParams.contractType && reqParams.contractType !== "-"
        ? reqParams.contractType
        : "",
    term: reqParams.period ? reqParams.period.replace("-", "") : "",
    page: reqParams?.page || 0,
    size: 10,
  });
}

function apiCancalledMatchCertificate(reqParams) {
  return API_POST("exchange-order-match/cancel", {
    matchIds: reqParams?.matchIds,
    description: reqParams?.matchDescription,
    status: reqParams?.matchStatus,
  });
}
